import { Pager } from '../common/pagination.model';

export type BranchSocialPlatform = 'facebook' | 'instagram' | 'snapchat' | 'youtube' | 'twitter';

export interface BranchApiMediaAsset {
  name?: string;
  url?: string | null;
  image_url?: string | null;
  previewUrl?: string | null;
  preview_url?: string | null;
  key?: string | null;
}

export interface BranchApiVideoItem {
  link: string;
  thumbnail: BranchApiMediaAsset | null;
}

export interface BranchApiTranslation {
  id: string;
  branch_id: string;
  language: string;
  name: string;
  country?: string | null;
  address?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface BranchApiRecord {
  id: string;
  country: string;
  address: string;
  location_url: string;
  support_contact: string;
  technician_contact: string;
  timings: string;
  status: boolean;
  position: number;
  social_popups: Record<BranchSocialPlatform, BranchApiMediaAsset | null>;
  gallery: BranchApiMediaAsset[];
  videos: BranchApiVideoItem[];
  translations: BranchApiTranslation[];
  translation?: BranchApiTranslation | null;
  createdAt: string;
  updatedAt: string;
}

export interface BranchApiListResponse extends Pager {
  records: BranchApiRecord[];
}

export interface BranchUpsertPayload {
  country: string;
  address: string;
  location_url: string;
  support_contact: string;
  technician_contact: string;
  timings: string;
  status: boolean;
  social_popups: Record<BranchSocialPlatform, BranchApiMediaAsset | null>;
  gallery: BranchApiMediaAsset[];
  videos: BranchApiVideoItem[];
  translations: Array<{
    language: 'en-us' | 'ar-ae';
    name: string;
    country: string;
    address: string;
  }>;
}
